import React from "react";
import moment from "moment";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Badge } from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { injectIntl } from "react-intl";

/**
 * FacebookConversationList - Hiển thị danh sách cuộc hội thoại Facebook
 */
const FacebookConversationList = ({
  conversations,
  selectedConversation,
  onSelectConversation,
  loading,
  pages = [],
  selectedPageFilter = "",
}) => {
  if (loading) {
    return (
      <div className="d-flex flex-column h-100 align-items-center justify-content-center p-4 text-center">
        <div
          className="loading position-relative"
          style={{ height: 20, width: 20, margin: "0 auto" }}
        />
        <p className="text-muted mt-3">
          <IntlMessages id="chat.facebook.processing" />
        </p>
      </div>
    );
  }

  if (!conversations || conversations.length === 0) {
    return (
      <div className="p-4 text-center text-muted">
        <i className="iconsminds-facebook mb-2" style={{ fontSize: 40 }} />
        <p>
          <IntlMessages id="chat.facebook.no_messages" />
        </p>
        <small>
          <IntlMessages id="chat.facebook.no_messages_hint" />
        </small>
      </div>
    );
  }

  // Group conversations by page if multiple pages
  const getPageName = (pageId) => {
    const page = pages.find((p) => p.page_id === pageId);
    return page ? page.page_name : "Fanpage";
  };

  return (
    <PerfectScrollbar
      options={{ suppressScrollX: true, wheelPropagation: false }}
      style={{ height: "100%" }}
    >
      <div className="pt-2">
        {conversations.map((conv) => {
          const isSelected =
            selectedConversation && selectedConversation.id === conv.id;

          return (
            <div
              key={conv.id}
              className={`d-flex align-items-center p-3 cursor-pointer ${
                isSelected ? "bg-light" : ""
              }`}
              style={{
                borderLeft: isSelected
                  ? "3px solid #0084ff"
                  : "3px solid transparent",
                cursor: "pointer",
              }}
              onClick={() => onSelectConversation(conv)}
            >
              {/* Avatar */}
              <div className="mr-3 position-relative">
                {conv.customer_profile_pic ? (
                  <img
                    src={conv.customer_profile_pic}
                    alt={conv.customer_name}
                    className="rounded-circle"
                    style={{ width: 48, height: 48, objectFit: "cover" }}
                  />
                ) : (
                  <div
                    className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white"
                    style={{ width: 48, height: 48, fontSize: 18 }}
                  >
                    {conv.customer_name
                      ? conv.customer_name.charAt(0).toUpperCase()
                      : "K"}
                  </div>
                )}
                {/* Unread dot */}
                {!conv.is_read && (
                  <span
                    className="position-absolute bg-primary rounded-circle"
                    style={{
                      width: 12,
                      height: 12,
                      bottom: 0,
                      right: 0,
                      border: "2px solid white",
                    }}
                  />
                )}
              </div>

              {/* Content */}
              <div className="flex-grow-1 overflow-hidden">
                <div className="d-flex justify-content-between align-items-center">
                  <h6
                    className={`mb-0 text-truncate ${
                      !conv.is_read ? "font-weight-bold" : ""
                    }`}
                    style={{ maxWidth: "70%" }}
                  >
                    {conv.customer_name || "Khách hàng"}
                  </h6>
                  <small className="text-muted">
                    {conv.last_message_time
                      ? moment(conv.last_message_time).fromNow()
                      : ""}
                  </small>
                </div>
                <p
                  className={`mb-0 text-truncate small ${
                    !conv.is_read
                      ? "font-weight-semibold text-dark"
                      : "text-muted"
                  }`}
                >
                  {conv.last_message || "..."}
                </p>
                {/* Page badge if multiple pages and no specific page is selected */}
                {pages.length > 1 && !selectedPageFilter && (
                  <Badge
                    color="light"
                    className="mt-1"
                    style={{ fontSize: 10 }}
                  >
                    {getPageName(conv.page_id)}
                  </Badge>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </PerfectScrollbar>
  );
};

export default injectIntl(FacebookConversationList);
